import SignUpLayout from "../../components/signup/layout";
import ChangeNumber from "./change-number";
import { useLocation } from "react-router-dom";

export default function ChangeNumberLayout() {
  const location = useLocation();
  return (
    <SignUpLayout
      step={location.pathname === "/signup/payment" ? 6 : 7}
      type={location.pathname === "/signup/ngn" ? 40 : 0}
      steps={location.pathname === "/signup/payment" ? [4, 5, 6] : [5, 6, 7]}
    >
      <ChangeNumber />
    </SignUpLayout>
  );
}
